/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ImageGenerationRequest,
  ImageGenerationStartResponse,
  SmartProblemDetails,
} from '../models/index';
import {
    ImageGenerationRequestFromJSON,
    ImageGenerationRequestToJSON,
    ImageGenerationStartResponseFromJSON,
    ImageGenerationStartResponseToJSON,
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

export interface CancelImageGenerationPostRequest {
    processId?: string;
}

export interface ImageGenerationGetImagesByIdsRequest {
    imageIds?: Array<string>;
}

export interface ImageGenerationOnPostRequest {
    imageGenerationRequest?: ImageGenerationRequest;
}

/**
 * 
 */
export class ImageGenerationApi extends runtime.BaseAPI {

    /**
     */
    async cancelImageGenerationPostRaw(requestParameters: CancelImageGenerationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['processId'] != null) {
            headerParameters['processId'] = String(requestParameters['processId']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/ImageGeneration/CancelImageGeneration`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async cancelImageGenerationPost(requestParameters: CancelImageGenerationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.cancelImageGenerationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async imageGenerationGetImagesByIdsRaw(requestParameters: ImageGenerationGetImagesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['imageIds'] != null) {
            queryParameters['imageIds'] = requestParameters['imageIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/ImageGeneration`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async imageGenerationGetImagesByIds(requestParameters: ImageGenerationGetImagesByIdsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.imageGenerationGetImagesByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async imageGenerationOnPostRaw(requestParameters: ImageGenerationOnPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImageGenerationStartResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/ImageGeneration`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImageGenerationRequestToJSON(requestParameters['imageGenerationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImageGenerationStartResponseFromJSON(jsonValue));
    }

    /**
     */
    async imageGenerationOnPost(requestParameters: ImageGenerationOnPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImageGenerationStartResponse> {
        const response = await this.imageGenerationOnPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
